import { useMemo } from "react";
import type { GameData, StyleTheme } from "@/interfaces";
import { getThemeConfig, type ThemeConfig } from "@/lib/theme-utils";

/**
 * Hook to get theme configuration based on game data
 * @param gameData - The game data containing style_theme
 * @returns Theme configuration object
 */
export function useStyleTheme(gameData?: GameData | null): ThemeConfig {
  return useMemo(() => {
    const styleTheme: StyleTheme = gameData?.style_theme || "superplay";
    return getThemeConfig(styleTheme);
  }, [gameData?.style_theme]);
}

/**
 * Hook to get just the style theme name
 * @param gameData - The game data containing style_theme
 * @returns The style theme name
 */
export function useStyleThemeName(gameData?: GameData | null): StyleTheme {
  return gameData?.style_theme || "superplay";
}
